module.exports = __webpack_public_path__ + "img/5.70cd7e8b.jpg";